<template>
  <div>
    <div class="col-md-12">
        <h3>Transferência</h3>
        
        <section>
            <div id="container-contacts-form" class="container d-flex">
                <div class="text-align-start formHeader">
                    <img src="/imgs/icons/adv-logo-sm.png" alt="Advance Management Logo" style="max-width: 2em; margin-right: .5em">
                    <span style="vertical-align: middle; font-weight: 600">Transferência</span>
                </div>
                <div id="contacts-form">

                    <div class="input-group">
                        <label for="de">De</label>
                        <select class="form-control" name="de" id="de" v-model="transfer.de" style="flex: 1">                
                            <option v-for="item in contactEquipeOption" :value="item.extension_line">{{ item.name }}</option>
                        </select>
                    </div>

                    <div class="input-group">
                        <label for="de">Para</label>
                        <select class="form-control" name="para" id="para" v-model="transfer.para" style="flex: 1">                
                            <option v-for="item in contactEquipeOption" :value="item.extension_line">{{ item.name }}</option>
                        </select>
                    </div>
        
                    <div v-if="saving">
                        <p id="saving"><strong><i class="fas fa-spinner fa-pulse"></i> Salvando contato...</strong></p>
                    </div>
                    <div v-else >

                        <button    
                            class="btn btn-success"
                            id="btn-save"
                            @click="saveContact()"
                        ><i class="fas fa-check"></i>
                            Transferir
                        </button>
                        
                    </div>
                </div>
            </div>
        </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { exit } from 'process';

export default {
    data(){
        return {
            saving: false,
            contactEquipeOption: '',
            transfer: {
                de: "",
                para: ""
            }
        }
    },
    created() {
        axios.get('/user/list').then(({data}) => {
            this.contactEquipeOption = data.data;
        });
    },
    methods:{
        checkForm: function(){
            if (this.transfer.de == ''){
                Swal.fire({
                    html: 'O campo "DE" é um campo obrigatório!',
                    type: "warning",
                    showCloseButton: true,
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
                });
                return false;
            }
            if (this.transfer.para == ''){
                Swal.fire({
                    html: 'O campo "PARA" é um campo obrigatório!',
                    type: "warning",
                    showCloseButton: true,
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
                });
                return false;
            }

            if (this.transfer.de == this.transfer.para){
                Swal.fire({
                    html: 'O campo "DE" e "PARA" não podem ser iguais',
                    type: "warning",
                    showCloseButton: true,
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
                });
                return false;
            }

            return true;
        },
        saveContact: function(){
            if(this.checkForm()){
                this.saving = true;

                axios.post("dialer/transferContact", this.transfer).then((ret) => {
                    this.saving = false;

                    if(ret.data.status == "success"){
                        Swal.fire({
                            type: "success",
                            title: "Feito!",
                            text: "Contatos transferidos com sucesso!"
                        })
                    }
                    else{
                        Swal.fire({
                            type: "warning",
                            title: "Erro!",
                            text: "Ocorreu um erro ao transferir!"
                        })
                    }
                })
            }
        }
    }
}
</script>

<style scoped>
    .formHeader {
        background-color: rgb(28,134,154);
        border-top: 3px solid #f38630;
        color: white;
        padding: 0.2em;
        display: flex;
        border-radius: 20px 20px 0px 0px
    }

    .input-group{
        width: 90%;
        align-self: center;
        line-height: 2.55;
    }

    #container-contacts-form{
        margin: 3em;
        width: 40vw;
        border: solid 2px lightgray;
        border-radius: 25px;
        text-align: center;
        flex-direction: column;
        margin: 10px;
        padding: 0
    }

    #saving {
        color: rgb(28,134,154);
        font-size: 16px;
        text-align: center
    }

    #div-title {
        display: flex;
        flex-direction: column;
        margin: 20px;
    }

    #contacts-form{
        display: flex;
        flex-direction: column;
        text-align: center;
    }

    #buttonGroup {
        display: flex;
        justify-content: center;
    }

    #btn-save {
        border: solid 2px #008000;
        border-radius: 20px;
        background-color: #008000;
        color: white;
        transition: 0.5s
    }
    
    #btn-save:hover {
        color: #008000;
        background-color: white;

    }

    #btn-cancel {
        border: solid 2px #b30000;
        border-radius: 20px;
        background-color: #b30000;
        color: white;
        transition: 0.5s
    }
    
    #btn-cancel:hover {
        color: #b30000;
        background-color: white;

    }

    .input-group label {
        width: 90px;
    }

    section {
        display: flex;
        justify-content: center;
    }

    h2 {
        color: rgb(28,134,154)
    }

    label{
        margin: 10px;
        font-size: 16px;
        font-weight: 500;
    }

    select {
        align-self: center;
    }

    input {
        width: 40px;
        align-self: center;
    }

    button {
        width: 120px;
        margin: 20px;
        border-radius: 10px !important
    }
</style>